<div class="questions">
    <p-accordion *ngFor="let q of currentQuestions">
        <p-accordionTab header="{{q.question}}" class="accordionTab">
            <p>{{q.answer}}</p>
        </p-accordionTab>
    </p-accordion>
</div>